import React from "react";
import { ShieldCheck, Truck, Heart, Sparkles } from "lucide-react";
import { aboutInfo, WHATSAPP_LINK } from "../../mock";

const iconMap = { ShieldCheck, Truck, Heart };

const About = () => {
  return (
    <section id="sobre" className="relative py-20 md:py-28">
      <div className="pointer-events-none absolute top-1/2 -translate-y-1/2 right-0 w-[420px] h-[420px] rounded-full bg-[#8b5cf6]/10 blur-[120px]" />
      <div className="pointer-events-none absolute top-0 left-0 w-[360px] h-[360px] rounded-full bg-[#ec4899]/10 blur-[120px]" />

      <div className="relative max-w-4xl mx-auto px-5 text-center">
        <span className="text-sm font-bold tracking-[0.2em] text-[#38bdf8] uppercase">
          {aboutInfo.label}
        </span>
        <h2 className="mt-4 font-display font-bold text-white text-3xl md:text-5xl leading-tight">
          {aboutInfo.title}
        </h2>
        <p className="mt-6 text-gray-400 text-lg leading-relaxed max-w-2xl mx-auto">
          {aboutInfo.text}
        </p>
      </div>

      {/* Bullets */}
      <div className="relative max-w-5xl mx-auto px-5 mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
        {aboutInfo.bullets.map((b) => {
          const Icon = iconMap[b.icon];
          return (
            <div
              key={b.title}
              className="rounded-3xl border border-white/8 bg-[#0f0e17] p-8 text-center transition-all duration-300 hover:-translate-y-1.5 hover:border-[#ec4899]/30"
            >
              <div className="w-14 h-14 rounded-2xl bg-[#ec4899]/15 flex items-center justify-center mx-auto mb-5">
                <Icon size={26} className="text-[#ec4899]" />
              </div>
              <h3 className="font-display font-bold text-white text-lg mb-3">
                {b.title}
              </h3>
              <p className="text-gray-400 leading-relaxed">{b.desc}</p>
            </div>
          );
        })}
      </div>

      <div className="relative text-center mt-12">
        <a
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 rounded-full bg-[#38bdf8] hover:bg-[#0ea5e9] text-[#06283d] font-extrabold text-base px-9 py-4 shadow-lg shadow-sky-500/25 transition-all hover:-translate-y-0.5"
        >
          <Sparkles size={18} /> {aboutInfo.cta}
        </a>
      </div>
    </section>
  );
};

export default About;
